import React, { useEffect, useState } from "react";
import { fetchPollByPost, votePoll } from "../../Services/engagementService";

/**
 * Renders poll attached to a post (loads by PostId). Additive UI — hidden when no poll.
 */
const PollCard = ({ postId }) => {
  const [poll, setPoll] = useState(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!postId) return undefined;
    (async () => {
      try {
        const data = await fetchPollByPost(postId);
        if (!cancelled) setPoll(data);
      } catch {
        if (!cancelled) setPoll(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [postId]);

  if (!poll?.pollId && !poll?.PollId) return null;

  const pollId = poll.pollId ?? poll.PollId;
  const options = poll.options ?? poll.Options ?? [];
  const expired = poll.isExpired ?? poll.IsExpired;
  const total = poll.totalVotes ?? poll.TotalVotes ?? 0;

  const onVote = async (optionId) => {
    if (busy || expired) return;
    setBusy(true);
    try {
      const updated = await votePoll(pollId, [optionId]);
      if (updated) setPoll(updated);
    } catch {
      /* toast handled globally if any */
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="wlj-poll-card mt-2 mb-2 p-2 border rounded">
      {(poll.description || poll.Description) && (
        <div className="mb-2 small text-muted">{poll.description || poll.Description}</div>
      )}
      {options.map((opt) => {
        const id = opt.plOptionId ?? opt.PlOptionId;
        const text = opt.text ?? opt.Text;
        const count = opt.voteCount ?? opt.VoteCount ?? 0;
        const mine = opt.votedByMe ?? opt.VotedByMe;
        const pct = total > 0 ? Math.round((count / total) * 100) : 0;
        return (
          <button
            type="button"
            key={id}
            className={`btn btn-sm w-100 text-start mb-1 ${mine ? "btn-primary" : "btn-outline-secondary"}`}
            disabled={busy || expired}
            onClick={() => onVote(id)}
          >
            <span>{text}</span>
            <span className="float-end">{pct}% ({count})</span>
          </button>
        );
      })}
      <div className="small text-muted">
        {total} vote{total === 1 ? "" : "s"}
        {expired ? " · closed" : ""}
      </div>
    </div>
  );
};

export default PollCard;
